var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 19,
    viewBox: "0 0 26 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.4881 1.77355C25.8281 2.46141 25.8281 3.36141 25.8281 5.16141V12.8757C25.8281 14.6757 25.8281 15.5757 25.4881 16.2636C25.1883 16.8682 24.71 17.3597 24.1219 17.6676C23.4531 18.0186 22.5781 18.0186 20.8281 18.0186H5.82812C4.07812 18.0186 3.20312 18.0186 2.53437 17.6676C1.94672 17.3595 1.46892 16.868 1.16938 16.2636C0.828125 15.5757 0.828125 14.6757 0.828125 12.8757V5.16141C0.828125 3.36141 0.828125 2.46141 1.16938 1.77355C1.46871 1.16863 1.94653 0.676705 2.53437 0.368269C3.20312 0.0185545 4.07812 0.0185547 5.82812 0.0185547H20.8281C22.5781 0.0185547 23.4531 0.0185545 24.1219 0.368269C24.7102 0.676487 25.1885 1.16844 25.4881 1.77355ZM22.5194 2.58998H4.13688C4.00267 2.58981 3.87198 2.63408 3.76414 2.71623C3.65629 2.79838 3.57702 2.91406 3.53805 3.04615C3.49907 3.17823 3.50247 3.31971 3.54773 3.44966C3.59299 3.57961 3.67772 3.69112 3.78938 3.7677L12.6331 9.8517C12.8388 9.99321 13.0807 10.0687 13.3281 10.0687C13.5756 10.0687 13.8175 9.99321 14.0231 9.8517L22.8669 3.7677C22.9785 3.69112 23.0633 3.57961 23.1085 3.44966C23.1538 3.31971 23.1572 3.17823 23.1182 3.04615C23.0792 2.91406 23 2.79838 22.8921 2.71623C22.7843 2.63408 22.6536 2.58981 22.5194 2.58998Z",
    fill: "#63C0DA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.fadfb55bcc3560db0966f4e953a35595.svg";
export { ForwardRef as ReactComponent };